import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import {
  NOTIFICATIONS_QUERY_KEY,
  NOTIFICATION_UNREAD_COUNT_QUERY_KEY,
  PLATFORM_NOTIFICATIONS_QUERY_KEY,
  PLATFORM_NOTIFICATION_UNREAD_COUNT_QUERY_KEY,
} from "../../query/keys";
import { markAllAsReadRequest } from "../requests/notification/notification";
import { markAllPlatformAsReadRequest } from "../requests/notification/platformNotification";
import { isSuperAdminRole } from "../../contexts/auth/utils";

export const useMarkAllAsRead = () => {
  const { token } = useAuth();
  const queryClient = useQueryClient();
  const isPlatform = isSuperAdminRole(token);

  return useMutation({
    mutationFn: () =>
      isPlatform
        ? markAllPlatformAsReadRequest(token!)
        : markAllAsReadRequest(token!),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: isPlatform
          ? PLATFORM_NOTIFICATIONS_QUERY_KEY
          : NOTIFICATIONS_QUERY_KEY,
      });
      queryClient.invalidateQueries({
        queryKey: isPlatform
          ? PLATFORM_NOTIFICATION_UNREAD_COUNT_QUERY_KEY
          : NOTIFICATION_UNREAD_COUNT_QUERY_KEY,
      });
    },
  });
};
